
import StringUtils from "../../../utils/StringUtils.js";
import RcDomainMap from "../../common/RcDomainMap.js";
import Label from './Label.js';
import LabelUtils from "./LabelUtils.js";

export default class LabelMap extends RcDomainMap {
  static MODEL_NAME = "LabelMap";

  constructor(domain, data) {
    super(domain, data, "LabelMap");
  }

  getLabel(key) {
    var value = super.get(key);
    if (value) {
      return new Label(this.domain, value);
    }
    return new Label(this.domain);
  }

  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getLabel(key);
      values.push(item);
    }
    return values;
  }

  copy() {
    var data = this._copy();
    return new LabelMap(this.domain, data);
  }

  sortByCreatedDate() {
    var list = this.list();
    return list.sort(LabelUtils.SortByCreatedDate);
  }

  sort() {
    return this.sortByName();
  }

  sortByName() {
    var list = this.list();
    return list.sort(LabelUtils.SortByName);
  }

  sortBy(fieldName) {
    var list = this.list();
    let functionName = 'SortBy_' + fieldName;
    var func = LabelUtils[functionName];
    return list.sort(func);
  }

  find() {
    var keys = this.keys();
    var found = new LabelMap(this.domain, {});
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.labels().findById(key);
      var item = new Label(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    return found;
  }

  findByIds(ids = []) {
    const values = new LabelMap(this.domain);
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getLabel(key);
      if (ids.includes(item.id())) {
        values.push(item);
      }
    }
    return values;
  }

  findByNames(names = []) {
    const values = new LabelMap(this.domain);
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getLabel(key);
      if (names.includes(item.name())) {
        values.add(item);
      }
    }
    return values;
  }

  findByName(name) {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getLabel(key);
      if (StringUtils.eic(item.name(), name)) {
        return item;
      }
    }
    return new Label(this.domain);
  }

  pointers() {
    const values = new LabelMap(this.domain);
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getLabel(key);
      values.push(item.pointer());
    }
    return values;
  }

  displayString() {
    var display = "";
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getLabel(key);
      if (StringUtils.isEmpty(display)) {
        display = item.name();
      } else {
        display = display + ", " + item.name();
      }
    }
    return display;
  }

  findGroupType() {
    return this.findByType("group");
  }

  findDivisionType() {
    return this.findByType("division");
  }

  findByType(type) {
    var keys = this.keys();
    var found = new LabelMap(this.domain, {});
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.labels().findById(key);
      var item = new Label(this.domain, data);
      if (!item.isNew() && item.type() === type) {
        found.add(item);
      }
    }
    return found;
  }
}